
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { Alert } from 'src/app/public/car/models/alert.model';
import { CarCriteria } from 'src/app/public/car/models/car-criteria.model';
import { AppFunctions } from '../../constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';


@Component({
    selector: 'app-alerts',
    templateUrl: './alerts.component.html',
    styleUrl: './alerts.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule]
})
export class AlertsComponent {

  @Input() alerts: Alert[] = [];
  
  constructor(
  
    private store: Store, 
    private router: Router
    ) {

  }
  
  updateAlertStatus(alert: Alert){

    let temp: Alert = JSON.parse(JSON.stringify(alert));

    temp.active = !temp.active;

    this.store.dispatch(DealerActions.alertUpdateStatusSubmit({ businessLine: alert.criteria.businessLine!, alertId: temp.id, status: temp.active }));
  }

  executeAlert(alert: Alert){

    //let crt: CarCriteria = JSON.parse(JSON.stringify(alert.criteria));
    let crt: CarCriteria = Object.assign(new CarCriteria(), alert.criteria);
    crt.pageNumber = 0;
    crt.businessLine = undefined;

    this.router.navigate(
      ["/"+alert.criteria.businessLine!.toLocaleLowerCase()+"/search"],
      { queryParams: crt }
    );

  }

  editAlert(index: number){
    
  }

  deleteAlert(businessLine: CarBusinessLine, alertId: number){
    this.store.dispatch(DealerActions.alertDeleteSubmit({businessLine: businessLine, alertId: alertId}));  
  }

  dateFormat(dt: string): string{
  
      return AppFunctions.stringToDatetime(dt);
    }

}
